<template>
  <div class="device-list">
    <div class="device-list-main">
      <el-table :data="deviceList" border style="width: 100%" tooltip-effect="dark">
        <el-table-column label="设备号" width="190">
          <template slot-scope="scope" class="devicenumber-container">
            <div class="devicenumber-wrapper">
              {{ scope.row.deviceId }}
              <div class="iconfont icon-lost" v-if="scope.row.lossStatus == 1"></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="设备绑定的手机号" width="190">
          <template slot-scope="scope">
            <div
              class="device-info-wrapper"
              :class="scope.row.devicePhone ? 'bound' : 'unbound'"
            >
              <i class="iconfont icon-unbound" v-if="!scope.row.devicePhone" />{{
                scope.row.devicePhone ? scope.row.devicePhone : "未绑定手机号"
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="studentName" label="设备绑定的学生" width="150">
          <template slot-scope="scope">
            <div
              class="device-info-wrapper"
              :class="scope.row.studentId ? 'bound' : 'unbound'"
            >
              <i class="iconfont icon-unbound" v-if="!scope.row.studentId" />{{
                scope.row.studentId ? scope.row.studentName : "未绑定学生"
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="学生年级班级" width="330">
          <template slot-scope="scope">
            <div
              class="device-info-wrapper font-hidden"
              :class="scope.row.studentId ? 'bound' : 'unbound'"
            >
              <i class="iconfont icon-unbound" v-if="!scope.row.studentId" />{{
                scope.row.studentName
                  ? scope.row.gradeName + scope.row.className
                  : "未绑定学生"
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="设备状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status == '1' ? 'success' : 'danger'">{{
              scope.row.status == "0"
                ? "未绑定"
                : scope.row.status == "1"
                ? "在线"
                : "离线"
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作">
          <template slot-scope="scope">
            <div class="device-operation-wrapper">
              <el-button
                type="primary"
                size="small"
                @click="lossBindingRelationship(scope.row)"
                v-hasPermi="'sc:stucard:loss'"
                ><i class="iconfont icon-report-loss" />{{
                  scope.row.lossStatus == 1 ? "取消挂失" : "设备挂失"
                }}</el-button
              >
              <el-button
                type="warning"
                size="small"
                :disabled="!scope.row.studentId"
                @click="editBindingRelationship(scope.row)"
                v-hasPermi="'sc:stucard:switchbind'"
                ><i class="iconfont icon-edit" />切换绑定</el-button
              >
              <el-button
                type="danger"
                icon="el-icon-delete"
                size="small"
                :disabled="!scope.row.studentId"
                @click="deleteBindingRelationship(scope.row)"
                v-hasPermi="'sc:stucard:delbind'"
                >删除绑定</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // deviceList: [
      //   {
      //     deviceNumber: "650522405531234",
      //     devicePhone: "13360816573",
      //     studentName: "张三",
      //     studentId: "2",
      //     gradeName: "一年级",
      //     className: "一班",
      //     deviceState: 1,
      //     isReportLoss: true,
      //   },
      //   {
      //     deviceNumber: "650522405127894",
      //     devicePhone: "15815086899",
      //     studentName: "王五",
      //     studentId: "1",
      //     gradeName: "一年级",
      //     className: "一班",
      //     deviceState: 0,
      //     isReportLoss: false,
      //   },
      //   {
      //     deviceNumber: "650522405154561",
      //     devicePhone: "",
      //     studentName: "",
      //     studentId: "",
      //     gradeName: "",
      //     className: "",
      //     deviceState: 0,
      //     isReportLoss: false,
      //   },
      // ],
    };
  },
  props: {
    deviceList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  inject: ["refresh"],
  mounted() {},
  methods: {
    // 删除绑定
    deleteBindingRelationship(deviceInfo) {
      this.$confirm(
        `是否删除设备号为${deviceInfo.deviceId}的设备与${deviceInfo.studentName}的绑定关系?`,
        "删除设备与学生的绑定关系",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.delete(
            `${this.$url.deletestudentdevicebind}?studentId=${deviceInfo.studentId}`
          )
            .then((res) => {
              // console.log("删除绑定结果==>", res);
              if (res.code != 200) {
                this.$message.error("删除绑定失败!");
                return;
              }
              this.$message.success("删除绑定成功");
              // 刷新列表
              this.refresh();
            })
            .catch((err) => {
              console.log("删除绑定报错==>", err);
            });
        })
        .catch(() => {
          // console.log("取消成功");
        });
    },
    // 挂失
    lossBindingRelationship(e) {
      this.$confirm(
        `${e.lossStatus == 0 ? "是否为该设备挂失?" : "是否为该设备取消挂失?"}`,
        "挂失",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.post(this.$url.updatedevice, {
            lossStatus: e.lossStatus == 0 ? 1 : 0,
            deviceId: e.deviceId,
            updateBy: this.user.id,
          }).then((res) => {
            // console.log("更改设备挂失状态==>", res);
            // 刷新列表
            this.refresh();
          });
        })
        .catch(() => {
          // console.log("取消成功");
        });
    },
    // 修改
    editBindingRelationship(e) {
      // console.log(e);
      this.$emit("create", e);
    },
  },
};
</script>

<style scoped lang="scss">
@import "./deviceList.scss";
</style>
